<script>
    import Config from '@/config';
    import {mapActions} from "vuex";
    import {wxClose} from '@/libs/util';
    import {sendLoginSms, smsGzBind} from '@/api';
    import {CellGroup, Form, Field, Button, Toast} from 'vant';

    export default {
        name: 'SmsLogin',
        components: {
            [Form.name]: Form,
            [Field.name]: Field,
            [Button.name]: Button,
            [CellGroup.name]: CellGroup
        },
        data() {
            return {
                mobile: '',

                code: '',
                codeText: '获取验证码',
                codeEnable: false,

                gzBind: false,
                loading: false,
                sending: false,
                loginButtonEnable: false
            };
        },
        computed: {
            buttonText() {
                return this.gzBind ? '绑定' : '登录';
            },
            loadingText() {
                return this.gzBind ? '绑定中...' : '登录中...';
            }
        },
        created() {
            if (this.$route.query.gzBind) {
                this.gzBind = true;
                window.document.title = '速电通-账号绑定';
            } else {
                window.document.title = '速电通-短信登录';
            }
        },
        methods: {
            ...mapActions([
                'handleSmsLogin'
            ]),
            mobileChange(value) {
                this.codeEnable = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/g.test(value) && !this.sending;
            },
            codeChange(value) {
                this.loginButtonEnable = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/g.test(this.mobile)
                    && /^\d{6}$/g.test(value);
            },
            getCode() {
                if (!this.codeEnable || this.sending) {
                    return;
                }

                this.sending = true;
                sendLoginSms(this.mobile).then(response => {
                    if (response.data.code === Config.successCode) {
                        this.countDown();
                    }
                });
            },
            countDown() {
                let waitTimeSeconds = 60;
                let intervalId = setInterval(() => {
                    if (waitTimeSeconds === 0) {
                        clearInterval(intervalId);
                        this.sending = false;
                        this.codeText = '发送验证码';
                        this.codeEnable = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/g.test(this.mobile);
                    } else {
                        this.codeText = waitTimeSeconds-- + '秒后重新获取';
                    }
                }, 1000);
            },
            onSubmit() {
                if (!this.loginButtonEnable) {
                    return;
                }

                this.loading = true;
                if (this.gzBind) {
                    smsGzBind(this.$route.query.token, this.mobile, this.code).then(response => {
                        if (response.data.code === Config.successCode) {
                            Toast.success('绑定成功');
                        }
                    }).finally(() => {
                        this.loading = false;
                        wxClose();
                    });
                } else {
                    this.handleSmsLogin({mobile: this.mobile, code: this.code}).then(response => {
                        if (response.data.code === Config.successCode) {
                          this.$router.go(-1);
                        }
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            }
        }
    }
</script>

<template>
    <div class="sms-login">
        <img class="logo" alt="速电通" src="../assets/logo.png">
        <van-form @submit="onSubmit">
            <van-cell-group>
                <van-field clearable focus type="number" minlength="11" maxlength="11" label="手机号" placeholder="请输入手机号" titleWidth="60px" autocomplete="off" v-model="mobile" @input="mobileChange"/>
                <van-field clearable center use-button-slot type="number" minlength="6" maxlength="6" label="验证码" placeholder="请输入6位数字" titleWidth="60px" autocomplete="off" v-model="code" @input="codeChange">
                    <van-button plain slot="button" color="#009251" size="small" @click="getCode" :disabled="!codeEnable">{{codeText}}</van-button>
                </van-field>
            </van-cell-group>
            <div class="button">
                <van-button round block color="#009251" native-type="submit" :loading-text="loadingText" :loading="loading" :disabled="!loginButtonEnable">
                    {{buttonText}}
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<style scoped lang="stylus">
    .sms-login
        text-align center

    .sms-login .logo
        height 50px
        width: 100px
        margin 24px

    .sms-login .button
        margin: 24px

        .van-button
            box-shadow 0 3px 6px 1px rgba(0, 146, 81, 0.41)
</style>
